export function wiss_showMap(region: string, toggle: number): void {
  const hideElements = document.querySelectorAll('.wiss_map_background:not(.wiss_map_' + region);
  const tooltip: HTMLFormElement | null = document.querySelector('.wiss_map_tooltip_' + region);
  const leitfaden: HTMLFormElement | null = document.querySelector(' .wiss_map_leitfaden_' + region);
  const info: HTMLFormElement | null = document.querySelector(' .wiss_map_tooltip_info');

  if (toggle === 1) {
    if (tooltip && leitfaden) {
      tooltip.style.display = 'block';
      leitfaden.style.display = 'block';
    }

    if (region !== 'info') {
      hideElements.forEach(element => element.classList.add('display_none'));
    } else {
      if (info) {
        info.style.display = 'block';
      }
    }
  } else {
    hideElements.forEach(element => element.classList.remove('display_none'));
    if (tooltip && leitfaden) {
      tooltip.style.display = 'none';
      leitfaden.style.display = 'none';
    }
    if (info) {
      info.style.display = 'none';
    }
  }
}

export function wiss_showHelp() {
  const tooltips = document.querySelectorAll('.wiss_map_tooltip:not(.wiss_map_tooltip_info)');
  tooltips.forEach(element => element.classList.add('display_block'));

  const hilfe: HTMLFormElement | null = document.querySelector('.wiss_map_hilfe');
  if (hilfe) {
    hilfe.style.display = 'block';
  }

  const infoOverlay: HTMLFormElement | null = document.querySelector('.wiss_info_overlay');
  if (infoOverlay) {
    infoOverlay.style.display = 'block';
  }
}

export function wiss_hideHelp() {
  const tooltips = document.querySelectorAll('.wiss_map_tooltip');
  tooltips.forEach(element => element.classList.remove('display_block'));

  const hilfe: HTMLFormElement | null = document.querySelector('.wiss_map_hilfe');
  if (hilfe) {
    hilfe.style.display = 'none';
  }

  const infoOverlay: HTMLFormElement | null = document.querySelector('.wiss_info_overlay');
  if (infoOverlay) {
    infoOverlay.style.display = 'none';
  }
}
